import { PatronConfiguration } from "../client/interfaces";

export const mockPatronConfiguration: PatronConfiguration = {
  pendingFeatureAnnouncements: ["patron_notifications"],
  reservation: {
    pickupLocations: [
      {
        branch: {
          code: "mbs",
        },
      },
      {
        branch: {
          code: "hks",
        },
      },
      {
        branch: {
          code: "mb",
        },
      },
    ],
  },
};
